class JointImageSuffix{
    constructor(){
        //存储浏览器信息 
        this.ua = this.getUa() ;
    }

    //获取浏览器信息
    getUa(){
        let userAgent = navigator.userAgent.toLowerCase();
        return {
            iphone: /(iphone|ipod|ipad)/i.test(userAgent),//ios设备
            android: /android/.test(userAgent), //安卓设备
            kkmh: /kuaikan\//.test(userAgent), //kk客户端
            pc: !/(iphone|ipod|ipad|android|webos|blackberry)/.test(userAgent),//pc设备
            isChrome: navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") == -1 ,//Chrome内核浏览器,并且不是Edge浏览器
        }
    }

    //设置屏幕密度
    getDpr(){
        let dpr = parseInt( window.devicePixelRatio ? window.devicePixelRatio : 1 );
        dpr = dpr < 1 ? 1 : dpr; //如果小于1的情况下, dpr复制为1
        dpr = dpr > 3 ? 3 : dpr; //如果大于3的情况下, dpr复制为3\
        if(!this.dpr || this.dpr != dpr){
            this.dpr = dpr;
        }
    }

    //设置屏幕可视区宽度 
    getScreenWidth(){
        let screenWidth = window.screen.width || document.body.clientWidth;
        screenWidth = screenWidth ? screenWidth : document.documentElement.clientWidth;
        if(!this.screenWidth || this.screenWidth != screenWidth){
            this.screenWidth = screenWidth;
        }
    }


    //判断是否为有效数字
    isNumber(value) {
        if( !value && !(value===0||value==='0') ){ return false };
        value = Number(value);
        return typeof value === 'number' && !isNaN(value);
    }
    
    //判断是否为字符串
    isString(str){ 
        return (typeof str=='string')&&str.constructor==String; 
    } 

    //判断是否为布尔
    isBoolean(bool){
        return typeof bool === 'boolean';
    }

    /**
     * jointImageSuffix 图片拼接别名后缀
     * @intercept 是否截取传递来scr  非必填参数   类型:布尔    false :不截取   true:截取
     * @src     图片地址            必填参数    类型:string    
     * @width   要展示的图片宽度     必填参数    类型:int   备注传递:设计稿的宽度(H5设计稿:750)
     * @quality 表示图片的质量       非必填      类型:string  支持值 h表示高质量，m表示中质量，l，表示low低质量
     * @p       表示图片渐进式       非必填      只针对jpg格式有效
     *  */ 
    jointImageSuffix({ intercept=true, src='', width=50,  quality='h', p=false}={}){
        this.getDpr(); //设置屏幕密度
        this.getScreenWidth(); //设置屏幕可视区宽度 
        let UA = this.ua ? this.ua : {};//获取浏览器信息
        if(!UA.pc){
            width  = Math.ceil(width / 2);  
            width = Math.floor(width / 375 * this.screenWidth);   
        }
        const realWidth = width * this.dpr;//视图宽度*屏幕密度 = 图片视图的宽度
        let target, format, newsrc;
        /**
         *  -watermark    添加水印
            -compress     压缩图片
            -watermark--compress   有水印也压缩
            -compress-gue   压缩
            -crop{n}-{n}    长图会进行裁剪
            -cover     -客户端视频封面(未找到实例) 待后期添加
         * **/

        // 兼容脏数据
        newsrc = src;
        //判断是否 intercept=ture 截取src  intercept=false不截取src
        if(intercept){
            // -watermark:添加水印图片  -watermark-compress:加水印压缩图片  -compress:压缩图片
            let isWatermarkCompress=/(-watermark$)|(-compress$)|(-compress-gue$)|(-cover$)/g.test(newsrc); //匹配压缩/加水印图片
            let isWatermark = /-crop(\d{1,10})-(\d{1,10})$/g.test(newsrc);//长图会进行裁剪
            if(!isWatermark && !isWatermarkCompress){ //非社区返回类型图片进行,拆分url
                let reg = /-((c\.w\.i\d+|c\.w\d+|cw\.w\d+)|(fe\.w\d+)|(h\.w\d+)|(h\.w\.i\d+)|(icon)|(o\d+)|(o\.i\d+)|(t\.w\d+)|(w\d+)|(yyb)|(lw\d+))[\s\S]*$/g; //匹配后缀为 -t* -c* -fe.* -h* -icon* -o* -w* -yyb* -lw* 的图片后缀替换为空 

                if(reg.test(src)){
                    newsrc = src.replace(reg,'');
                }else if(/\.webp\.w\.jpg/.test(src)) {
                    newsrc = src.replace(/\.webp\.w\.jpg/, ".webp");
                };
            }
        }
        
        

        // 过滤 gif
        if (/.gif$/.test(newsrc)) {
            return newsrc
        }

        //设置要加载图片宽度
        if (realWidth <= 50) {
            target = 50
        } else if (realWidth <= 70) {
            target = 70
        } else if (realWidth <= 90) {
            target = 90
        } else if (realWidth <= 120) {
            target = 120
        } else if (realWidth <= 180) {
            target = 180
        } else if (realWidth <= 207) {
            target = 207
        } else if (realWidth <= 320) {
            target = 320
        } else if (realWidth <= 360) {
            target = 360
        } else if (realWidth <= 414) {
            target = 414
        } else if (realWidth <= 540) {
            target = 540
        } else if (realWidth <= 563) {
            target = 563
        } else if (realWidth <= 640) {
            target = 640
        } else if (realWidth <= 720) {
            target = 720
        } else if (realWidth <= 750) {
            target = 750
        } else if (realWidth <= 828) {
            target = 828
        } else if (realWidth <= 960) {
            target = 960
        } else if (realWidth <= 1080) {
            target = 1080
        } else if (realWidth <= 1125) {
            target = 1125
        } else if (realWidth <= 1280) {
            target = 1280
        } else if (realWidth <= 1440) {
            target = 1440
        } else if (realWidth <= 1600) {
            target = 1600
        } else if (realWidth <= 2160) {
            target = 2160
        }else{
            target = 2160;//参数异常的情况
        };

        if(UA.pc){
            //pc项目
            if (UA.isChrome) {//Chrome内核浏览器
                format = 'webp';
            }else{//其它浏览器
                format = 'jpg';
                //png 图片
                if (/.png$/.test(newsrc)) {
                    format = 'png';
                }
            }     
        }else{
            //H5 项目
            if(UA.android){ //安卓设备
                format='webp'
            }else{ //ios设备或者其他设备
                format='jpg'
                if (/.png$/.test(newsrc)) {
                    format = 'png';
                }
            }
        }
        

        let q ; //设置图片的质量
        if(quality == 'h' || quality == 'm' || quality == 'l'){
            q = quality
        }else{
            q = 'h'; 
        };

        let imgUrl = `${newsrc}-t.w${target}.${format}.${q}`;
        if(p && format == 'jpg' ){ //表示图片渐进式 , 只针对jpg格式有效
            imgUrl = imgUrl + '.p'
        }
        return imgUrl;
    } 
}

//实例化
const initImgSrc = new JointImageSuffix();


/**
 * jointImageSuffix 图片拼接别名后缀
 * @intercept 是否截取传递来scr  非必填参数   类型:布尔    false :不截取   true:截取  默认:true 截取
 * @src     图片地址            必填参数    类型:string     参数异常,返回传入的src并抛出异常  
 * @width   要展示的图片宽度     必填参数    类型:int    备注传递:设计稿的宽度(H5设计稿:750)  参数异常,返回传入的src并抛出异常  
 * @quality 表示图片的质量       非必填      类型:string 默认:'h' 支持值 h表示高质量，m表示中质量，l，表示low低质量
 * @p       表示图片渐进式       非必填      类型:Boolean  默认:false 只针对jpg格式有效
 *  */
function jointImageSuffix ({ intercept=true, src='', width=50,  quality='h' , p=false}={}) {
    if( !initImgSrc.isString(src) || !src){
        console.warn('src参数异常',src);
        return src;
    };
    if( !initImgSrc.isNumber(width) ){
        console.warn('width参数异常',width);
        return src;
    };
    if( !initImgSrc.isString(quality) ){
        console.warn('quality参数异常',quality);
        return src;
    };
    p = initImgSrc.isBoolean(p) ? p : false;//判断是否为布尔类型 
    const imgSrc =  initImgSrc.jointImageSuffix({intercept, src, width,  quality, p});
    return imgSrc;
}

window.jointImageSuffix = jointImageSuffix; //本地测试demo 需要打开

export default jointImageSuffix;



// WEBPACK FOOTER //
// ./node_modules/@kkmh/image-format/src/image-format.js